/** Format unix seconds in an IANA timezone for display in the UI. */
export function formatUnixInTimeZone(
  unixSecs: number,
  timeZone: string,
  locale?: string,
): string {
  const loc =
    locale ??
    (typeof navigator !== "undefined" ? navigator.language : undefined) ??
    "en-US";
  try {
    return new Date(unixSecs * 1000).toLocaleString(loc, { timeZone });
  } catch {
    return new Date(unixSecs * 1000).toLocaleString(loc, { timeZone: "UTC" });
  }
}

export function allIanaTimeZones(): string[] {
  try {
    return Intl.supportedValuesOf("timeZone");
  } catch {
    return ["UTC"];
  }
}
